import {Injectable, NgZone} from '@angular/core';
import {Observable, of, timer} from 'rxjs';
import {catchError, switchMap, tap} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {IspmHttpClient} from '@ispm/core/services/ispm-http-client';

@Injectable()
export class DataMigrationService {

  public static entityTreeBaseUrl: string = 'entity-tree';

  constructor(
    protected _ispmHttp: IspmHttpClient,
    private _zone: NgZone
  ) {
  }

  /**
   * Trigger database rollback based on transaction UUID
   * @param sourceTransactionUUID
   */
  public triggerRollbackImport(sourceTransactionUUID: string, isChunk?: boolean): Observable<any> {
    if (sourceTransactionUUID) {
      let requestParams = isChunk ? {sourceTransactionUUIDChunk:sourceTransactionUUID} : {sourceTransactionUUID:sourceTransactionUUID};
      const req = this._ispmHttp.get(`${DataMigrationService.entityTreeBaseUrl}/rollbackImport`,requestParams,null,null,null,true).map((res)=> {
        return res;
      }).map((data) => {
        return data;
      }).catch(err => {
        return Observable.throwError(err);
      }).publish();
      req.connect();
      return this.bulkRollbackImportUntilExpiryDuration(req);
    }

  }

  /**
   * Validate database migration based on resource id
   * @param id
   */
  public validateDataMigration(rowData: any): Observable<any> {
    if (rowData) {
      let requestBody = {data:rowData};
      const req = this._ispmHttp.put(`${DataMigrationService.entityTreeBaseUrl}/dataMigrationValidate`,requestBody,null,null,null).map((res)=> {
        return res;
      }).map((data) => {
        return data;
      }).catch(err => {
        return Observable.throwError(err);
      }).publish();
      req.connect();
      return req;
    }

  }


  /**
   * Wait until rollback export completed
   * @param req
   */
  private bulkRollbackImportUntilExpiryDuration(req) {
    const timer$ = timer(0, 2400000);
    return timer$.pipe(
      tap(() => {
        this._zone.run(() => { // Bring back to zone
        });
      }),
      switchMap(() => {
        return req.pipe(catchError((err: HttpErrorResponse) => {
          console.error('failed to complete rollback export : Error : ', err.message);
          return of(null);
        }));
      })
    );
  }
}
